import React from "react";
import { Text, Button } from "@suralink/samurai/ui";
import styles from "../../styles/Login.module.scss";

interface mfaRecoveryProps {
  goToSignIn: any;
  coBrandingEnabled: boolean;
}

const MfaRecovery: React.FC<mfaRecoveryProps> = ({
  goToSignIn,
  coBrandingEnabled,
}) => {
  return (
    <div className={styles.mfaRecoveryContent}>
      <Text type="H2" className={styles.mfaRecoveryHeader}>
        Lost access to your authenticator?
      </Text>
      <div className={styles.mfaRecoveryGroup}>
        <Text type="H3" className={styles.mfaRecoverySubtext2}>
          Are you part of a firm?
        </Text>
        <Text type="Small2">
          Contact the admin at your firm, and request a recovery passcode. The
          recovery passcode, with instructions, will be sent to your email.
        </Text>
      </div>
      <div className={styles.mfaRecoveryGroup}>
        <Text type="H3" className={styles.mfaRecoverySubtext2}>
          Were you invited by a firm?
        </Text>
        <Text type="Small2">
          Contact your point of contact at the firm that invited you, and
          request that they have an admin send you a recovery passcode. The
          recovery passcode, with instructions, will be sent to your email.
        </Text>
      </div>
      <Button
        color="blue"
        onClick={goToSignIn}
        label="Back to sign in"
        className={styles.mfaRecoveryContentButton}
      />
      <hr
        style={{
          margin: `${coBrandingEnabled ? "36px auto" : "40px auto"}`,
        }}
      />
    </div>
  );
};

export default MfaRecovery;
